import React, {useState, useEffect} from "react";
import {Stack, Box, styled, Input, Button} from "@mui/material";
import Select from "react-select";
import {Badge, theme } from "@material-ui/core";
import FormWebTeam from "../form/FormWebTeam.jsx"

export default function FormNewWebTeam (props) {

    
   
   const [showWebTeam, setShowWebTeam]=useState(true);
   const [buttonOneLabel, setButtonOneLabel]=useState('SHOW WEB TEAM DATA');
   const topButtonOnClick = (e) =>{
    if(showWebTeam===true){
          setShowWebTeam(false);
          setButtonOneLabel('SHOW WEB TEAM FORM')
    }
    else{
      setShowWebTeam(true);
      setButtonOneLabel('SHOW WEB TEAM DATA')
    }
   }

    return (
     <Box m="20px">
      <Button type="submit" color="secondary" variant="contained"
      onClick={topButtonOnClick}
      >
        {buttonOneLabel}
      </Button>
      
      <br />

      {showWebTeam && (
        <div style={{height: '1200px'}}>
            <br/>
            <FormWebTeam />
        </div>
        )}
        
     </Box>
    )
}
